// extracted by mini-css-extract-plugin
export default {"box":"SvgAnimationBox__box-HWwH","loading":"SvgAnimationBox__loading-FmGe"};